import React from "react"
import Styled from "styled-components"
// UI
import {H2} from "@uprise/headings"
import {P} from "@uprise/text"
// Images
const corporateLandingArt = require("assets/images/art/landing.svg")

const Art = Styled.img`
	width: 480px;
	height: 376px;
	margin-bottom: 155px;

	@media (max-width: 1024px) {
		width: 350px;
	}
`

const WorkableLogoImage = Styled.img`
	width: 50%;
`

const RightContentCorporate = () => {
	return (
		<div>
			<H2 className='m-b-5' width='358px'>
				Mental fitness for you, and your team.
			</H2>
			<P width='405px' mediumWidth='305px' className='m-b-10'>
				Uprise helps you improve happiness, reduce stress & increase performance
			</P>
			<Art src={corporateLandingArt} alt='' />
		</div>
	)
}

export default RightContentCorporate
